import type {BookmarkDateRange} from 'common/widgets/date-range-picker/models/types';
import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {ProjectDetails} from 'common/report/stores/project-details';
import {CustomEventDefinition} from 'common/report/util/saved-entities/types';

import {QueryReason} from '../util/query-tracking/types';

export type BookmarkUpdateDetail<BookmarkParamsType = any> = {
  params: BookmarkParamsType;
  queryReason?: QueryReason;
  requery?: boolean;
  savedBehaviorId?: number;
  hasChangedChartType?: boolean;
};

export type BookmarkUpdateEvent<BookmarkParamsType = any> = CustomEvent<BookmarkUpdateDetail<BookmarkParamsType>>;

export type RequestOdaDetail = {
  bookmarkUrl: string;
  bookmarkDateRange: BookmarkDateRange;
};

export type RequestOdaEvent = CustomEvent<RequestOdaDetail>;

export type QueryContextFnParams = {
  project: CurrentProject | ProjectDetails;
  customEvents: CustomEventDefinition[];
};

export enum CsvExportAction {
  Export = `export`,
  Cancel = `cancel`,
}

export type CsvExportSpec =
  | {
      action: CsvExportAction.Export;
      exportLimit: number;
      // when this field exists, it indicates csv export limit can be customized
      maxCustomLimit?: number;
    }
  | {action: CsvExportAction.Cancel};
